import { render, staticRenderFns } from "./Calculation.vue?vue&type=template&id=4345bf5d&scoped=true"
import script from "./Calculation.vue?vue&type=script&lang=js"
export * from "./Calculation.vue?vue&type=script&lang=js"
import style0 from "./Calculation.vue?vue&type=style&index=0&id=4345bf5d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4345bf5d",
  null
  
)

export default component.exports